import script from "./Routing.vue?vue&type=script&setup=true&lang=ts"
export * from "./Routing.vue?vue&type=script&setup=true&lang=ts"

import "./Routing.vue?vue&type=style&index=0&id=10dddbfe&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10dddbfe"]])

export default __exports__